// Picture-library glyph for the "Captured / Key images" popup trigger. Inline SVG (rather than a
// PNG under /images like the other toolbar icons) so it stays crisp and inherits a single color.
// Default color matches the muted dark-gray of the agentic LLMTopBar toolbar icons.
const CapturedImagesIcon = ({ color = "#5b5b5b", size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Back frame (gives the "library / stack" feel) */}
    <path
      d="M7 4h11a2 2 0 0 1 2 2v9"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    {/* Front photo frame */}
    <rect x="3" y="7" width="14" height="12" rx="2" stroke={color} strokeWidth="1.6" />
    {/* Sun */}
    <circle cx="12.6" cy="10.6" r="1.3" fill={color} />
    {/* Mountain */}
    <path
      d="M3.5 16.5l3.2-3a1.4 1.4 0 0 1 1.95 0L13 17.5"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CapturedImagesIcon;
